export class BonusTableYearlyVariable {
    id!: string
    year!: number
    planPercent!: number
    bonusPoolPercent!: number
    overhead!: number
    plan!: number
    extra!: number
    otherIncome!: number
}
